/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LivenessPage from '@/components/liveness-page';
import { LivenessSceneEnum } from '@/enums/liveness-param';
import UbtHelper from '@/shared/tools/ubtHelper';
import { updateModuleState } from '@/store';
import { getDeviceInfo, setPageTitle } from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import { userActionTypeEnum } from '@/api/callBack/types';
import CallBackAPI from '@/api/callBack';
import { isH5App } from '@/constant';
import { OpenVerifyPageMode, VerifyQueryParamsTypeEnum } from '@/shared/verify-credit-controller/types';
import { VerifyEntireTypeEnum, VerifyStageEnum } from '@/views_v2/verify-credit/types';
import { agreementService } from '@/service/confirm-agreements';
import { goBackPreviousPage } from '@/shared/utils/goBack';
import { session } from '@/shared/utils/storage';

@Component({ name: 'BaseLiveness' })
export default class BaseLiveness extends Vue {
  @Prop(String) readonly openMode!: OpenVerifyPageMode;

  @Prop(String) readonly verifyEntireType!: string;

  @Prop(Object) readonly queryParams!: Record<string, unknown>;

  @Prop(Boolean) readonly ocrAfter!: boolean;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  @Prop(Boolean) readonly ocrComplete!: boolean;

  /** 若是ocr后置流程，先检验是否同意协议后，再展示活体认证弹窗 */
  private showLivenessPopup = !this.ocrAfter;

  private ubtHelper = new UbtHelper('臻有钱_活体识别');

  private pageTitle = '人脸认证';

  /** 是否在popup模式下 */
  private inPopupModeControl = this.openMode === OpenVerifyPageMode.POPUP_SHOW;

  /** 是否是 h5场景做活体后，重新加载当前页面(外采场景: popup模式) */
  private get isH5BioReload(): boolean {
    return (isH5App && this.inPopupModeControl) || platform.isWechatMini;
  }

  /** 针对 h5场景，获取活体唤起认证完成后（不管成功失败），跳转链接 */
  private get H5BioParamsRedirectUrl(): { redirectUrl?: string} {
    if (this.isH5BioReload) {
      const { type = '' } = this.queryParams;
      const sceneType = type === VerifyQueryParamsTypeEnum.ApplyForNoBankCard
        ? LivenessSceneEnum.NoBankCardApplyContract : LivenessSceneEnum.ConfirmApplyContract;
      /** 获取获取回跳链接的 “查询字符串起始符” */
      const queryStringDelimiter = window.location.href.indexOf('?') > -1 ? '&' : '?';

      return {
        /**
         * 阿里云活体验证成功后，回跳原始(信贷)页面
         * 1. 提现场景: 添加特殊参数标识popup
         */
        redirectUrl: this.verifyEntireType === VerifyEntireTypeEnum.LOAN
          ? `${window.location.href}${queryStringDelimiter}h5Bio=true&sceneType=${sceneType}`
          : `${window.location.href}${queryStringDelimiter}currentStage=${VerifyStageEnum.BIO_AUTH}`,
      };
    }
    return {};
  }

  /** 活体认证成功以后调用 */
  private bioSucFunc() {
    /** 新增 用户运营事件采集 -- 活体认证 scene 资料填写完成后，活体认证成功 */
    const params = {
      userAction: userActionTypeEnum.Liveness,
      scene: LivenessSceneEnum.MaterialSuccess,
    };

    CallBackAPI.userActionCallBack(params);
    /** 执行上层 success逻辑 */
    this.$emit('resolveProcessVerify');
  }

  private onSuccess() {
    this.bioSucFunc();
  }

  private async created() {
    const livenessHeadVisitKey = 'livenessHeadVisitKey';
    let forceCloseWebView = false;

    /**
     * 若活体页面是首位(history.length === 1)进入时，必要检验协议同意状态，若未同意 && 点击“不同意”就强制关闭页面
     */
    if (session.get(livenessHeadVisitKey)) {
      forceCloseWebView = Boolean(session.get(livenessHeadVisitKey));
    } else {
      session.set(livenessHeadVisitKey, window.history.length === 1);
    }

    /**
     * check用户同意协议，若用户不同意，则终止流程
     * ocr后置提现用户，前置已校验过协议，无需重复检验
     */
    if (this.ocrAfterLoan || (await agreementService.confirmFinanceAgreements())) {
      this.showLivenessPopup = true;
    } else {
      /** 兜底展示活体认证页，避免back无效而展示空白页面 */
      this.showLivenessPopup = true;
      goBackPreviousPage(forceCloseWebView);
    }
  }

  private mounted() {
    window.scrollTo(0, 0);
    setPageTitle('刷脸认证');

    this.ubtHelper.enterPage();
    this.$ubtPageButton('臻有钱_活体识别');

    /** 只针对客户端开放，后续针对小程序再做评估 */
    if (platform.isHelloApp) {
      getDeviceInfo().then((deviceInfo: NativeModel.DeviceInfo) => {
        updateModuleState('base', {
          deviceInfo,
        });
      }).catch(() => {
        // console.log(e)
      });
    }
  }

  private beforeDestroy() {
    this.ubtHelper.leavePage();

    if (this.pageTitle) {
      setPageTitle(this.pageTitle);
    }
  }

  private get requestApiParams(): Record<string, unknown> {
    return {
      ocrAfter: this.ocrAfter,
      ocrAfterLoan: this.ocrAfterLoan,
      ocrComplete: this.ocrComplete,
    };
  }

  private render() {
    return this.showLivenessPopup ? (
      <LivenessPage
        scene={LivenessSceneEnum.Authority}
        requestApiParams={this.requestApiParams}
        redirectUrl={this.H5BioParamsRedirectUrl.redirectUrl}
        onSuccess={this.onSuccess.bind(this)}
      />
    ) : null;
  }
}
